import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconTrain = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconTrain",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M160-340v-380q0-53 28-84t72-48 103-22 117-6q66 0 125 6t102 22 68 48 25 84v380q0 59-40 100t-100 40l20 20q17 17 8 39t-33 21q-7 0-13-2t-12-8l-70-70H400l-70 70q-5 5-11 8t-14 2q-23 0-32-21t7-39l20-20q-59 0-99-40t-41-100m80-220h200v-120H240zm280 0h200v-120H520zM340-320q26 0 43-17t17-43-17-43-43-17-43 17-17 43 17 43 43 17m280 0q26 0 43-17t17-43-17-43-43-17-43 17-17 43 17 43 43 17"
  })
}));